import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';
import { movie_report } from '../../../actions/Movie/movie';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor:"#000000"  ,
        color: "#ffffff !important",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function MovieDownload() {
    const dispatch = useDispatch();
    const report = useSelector((state) => state.movies.movie_report);
    
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    useEffect(() => {
        dispatch(movie_report());
    }, []);

    const handleFilter = () => {
        const params = {};
        
        if (startDate) {
            params.start_date = dayjs(startDate).format('YYYY-MM-DD');
        }
        if (endDate) {
            params.end_date = dayjs(endDate).format('YYYY-MM-DD');
        }
        
        dispatch(movie_report(params));
    };

    const handleReset = () => {
        setStartDate(null);
        setEndDate(null);
        dispatch(movie_report());
    };

    const handleSave = () => {
        const doc = new jsPDF();

        const tableColumn = [
            'Name',
            'Access Type',
            'Views',
            'Likes',
            'Downloads',
            'TVOD Amount',
            'Total Earning',
            'Tax',
            'Admin Profit',
            'Rental Count',
        ];

        const tableRows = report?.message?.map(row => ([
            row.name,
            row.access_type,
            row.view,
            row.like,
            row.downloads,
            row.tvod_amount || '-',
            row.total_earning || '-',
            row.tax_amount ?? '-',
            row.admin_profit ?? '-',
            row.total_rental_count ?? '-',
        ])) || [];

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            styles: { fontSize: 8 },
            margin: { top: 20 },
        });

        doc.save('movie_report.pdf');
    };

    return (
        <Box sx={{ m: 3 }}>
            <Box sx={{ my: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Start Date"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        slotProps={{ textField: { size: 'small' } }}
                    />
                    <DatePicker
                        label="End Date"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        minDate={startDate}
                        slotProps={{ textField: { size: 'small' } }}
                    />
                </LocalizationProvider>
                <Button variant="contained" onClick={handleFilter}>
                    Filter
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleReset}>
                    Reset
                </Button>
                <Button variant="outlined" onClick={handleSave}>
                    Save
                </Button>
            </Box>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="Movie Report Table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell align="right">Access Type</StyledTableCell>
                            <StyledTableCell align="right">Views</StyledTableCell>
                            <StyledTableCell align="right">Likes</StyledTableCell>
                            <StyledTableCell align="right">Downloads</StyledTableCell>
                            <StyledTableCell align="right">TVOD Amount</StyledTableCell>
                            <StyledTableCell align="right">Total Earning</StyledTableCell>
                            <StyledTableCell align="right">Tax</StyledTableCell>
                            <StyledTableCell align="right">Admin Profit</StyledTableCell>
                            <StyledTableCell align="right">Rental Count</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {report?.message?.map((row, index) => {
                            return (
                                <StyledTableRow key={index}>
                                    <StyledTableCell component="th" scope="row">{row.name}</StyledTableCell>
                                    <StyledTableCell align="right">{row.access_type}</StyledTableCell>
                                    <StyledTableCell align="right">{row.view}</StyledTableCell>
                                    <StyledTableCell align="right">{row.like}</StyledTableCell>
                                    <StyledTableCell align="right">{row.downloads}</StyledTableCell>
                                    <StyledTableCell align="right">{row.tvod_amount || '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.total_earning || '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.tax_amount ?? '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.admin_profit ?? '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.total_rental_count ?? '-'}</StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
